import { render } from "./BeneficialForm.vue?vue&type=template&id=31520876&ts=true"
import script from "./BeneficialForm.vue?vue&type=script&lang=ts"
export * from "./BeneficialForm.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__